/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */
// tslint:disable
export var IdLocaBalancing;
(function (IdLocaBalancing) {
    IdLocaBalancing["acorns"] = "acorns";
    IdLocaBalancing["acre"] = "acre";
    IdLocaBalancing["adventureCoins"] = "adventureCoins";
    IdLocaBalancing["adventureFarm"] = "adventureFarm";
    IdLocaBalancing["adventurePoints"] = "adventurePoints";
    IdLocaBalancing["almondOrchard"] = "almondOrchard";
    IdLocaBalancing["almonds"] = "almonds";
    IdLocaBalancing["aloeVera"] = "aloeVera";
    IdLocaBalancing["aloeVeraGel"] = "aloeVeraGel";
    IdLocaBalancing["alpacaStable"] = "alpacaStable";
    IdLocaBalancing["alpacafeed"] = "alpacafeed";
    IdLocaBalancing["alpacafeed_premium"] = "alpacafeed_premium";
    IdLocaBalancing["alpacafeed_seaweed"] = "alpacafeed_seaweed";
    IdLocaBalancing["alpacafeed_super"] = "alpacafeed_super";
    IdLocaBalancing["alpacas"] = "alpacas";
    IdLocaBalancing["amazonDragonStatue"] = "amazonDragonStatue";
    IdLocaBalancing["ancestralTree"] = "ancestralTree";
    IdLocaBalancing["andromedaObservatory"] = "andromedaObservatory";
    IdLocaBalancing["animalChessboard"] = "animalChessboard";
    IdLocaBalancing["animalSoccer"] = "animalSoccer";
    IdLocaBalancing["appleOrchard"] = "appleOrchard";
    IdLocaBalancing["apples"] = "apples";
    IdLocaBalancing["asianArchway"] = "asianArchway";
    IdLocaBalancing["autumnKing"] = "autumnKing";
    IdLocaBalancing["bakedFish"] = "bakedFish";
    IdLocaBalancing["bananaOrchard"] = "bananaOrchard";
    IdLocaBalancing["bananas"] = "bananas";
    IdLocaBalancing["barley"] = "barley";
    IdLocaBalancing["barley14Gain"] = "barley14Gain";
    IdLocaBalancing["barley15Haste"] = "barley15Haste";
    IdLocaBalancing["barley25Haste"] = "barley25Haste";
    IdLocaBalancing["barley27Gain"] = "barley27Gain";
    IdLocaBalancing["barley50Haste"] = "barley50Haste";
    IdLocaBalancing["barley8Gain"] = "barley8Gain";
    IdLocaBalancing["barn"] = "barn";
    IdLocaBalancing["beachBar"] = "beachBar";
    IdLocaBalancing["beanieGreen"] = "beanieGreen";
    IdLocaBalancing["beaniePlain"] = "beaniePlain";
    IdLocaBalancing["beaniePurple"] = "beaniePurple";
    IdLocaBalancing["beanieRed"] = "beanieRed";
    IdLocaBalancing["beeEventLeague"] = "beeEventLeague";
    IdLocaBalancing["beehive"] = "beehive";
    IdLocaBalancing["berries"] = "berries";
    IdLocaBalancing["berryOrchard"] = "berryOrchard";
    IdLocaBalancing["bigChristmasGift"] = "bigChristmasGift";
    IdLocaBalancing["bigEasterGift"] = "bigEasterGift";
    IdLocaBalancing["bigFarmStoryBalloons"] = "bigFarmStoryBalloons";
    IdLocaBalancing["bigPalmTree"] = "bigPalmTree";
    IdLocaBalancing["birdbath"] = "birdbath";
    IdLocaBalancing["blockBoards"] = "blockBoards";
    IdLocaBalancing["bonitaAlmondOrchard"] = "bonitaAlmondOrchard";
    IdLocaBalancing["bonitaAlmonds"] = "bonitaAlmonds";
    IdLocaBalancing["books"] = "books";
    IdLocaBalancing["breadCrumbs"] = "breadCrumbs";
    IdLocaBalancing["bricks"] = "bricks";
    IdLocaBalancing["buckets"] = "buckets";
    IdLocaBalancing["buildCoupons"] = "buildCoupons";
    IdLocaBalancing["buildings"] = "buildings";
    IdLocaBalancing["butterflyFeeder"] = "butterflyFeeder";
    IdLocaBalancing["butterflyStatue"] = "butterflyStatue";
    IdLocaBalancing["cabbage"] = "cabbage";
    IdLocaBalancing["cabbage13Gain"] = "cabbage13Gain";
    IdLocaBalancing["cabbage15Haste"] = "cabbage15Haste";
    IdLocaBalancing["cabbage25Gain"] = "cabbage25Gain";
    IdLocaBalancing["cabbage25Haste"] = "cabbage25Haste";
    IdLocaBalancing["cabbage50Haste"] = "cabbage50Haste";
    IdLocaBalancing["cabbage8Gain"] = "cabbage8Gain";
    IdLocaBalancing["cafeAndStore"] = "cafeAndStore";
    IdLocaBalancing["camp"] = "camp";
    IdLocaBalancing["camp1"] = "camp1";
    IdLocaBalancing["camp2"] = "camp2";
    IdLocaBalancing["camp3"] = "camp3";
    IdLocaBalancing["camp4"] = "camp4";
    IdLocaBalancing["camp5"] = "camp5";
    IdLocaBalancing["camp6"] = "camp6";
    IdLocaBalancing["candles"] = "candles";
    IdLocaBalancing["candy"] = "candy";
    IdLocaBalancing["candyAcre"] = "candyAcre";
    IdLocaBalancing["candyChickenCoop"] = "candyChickenCoop";
    IdLocaBalancing["candyComposter"] = "candyComposter";
    IdLocaBalancing["candyCowBarn"] = "candyCowBarn";
    IdLocaBalancing["candyFancyHouse"] = "candyFancyHouse";
    IdLocaBalancing["candyFarmHouse"] = "candyFarmHouse";
    IdLocaBalancing["candyHouse"] = "candyHouse";
    IdLocaBalancing["candyMill"] = "candyMill";
    IdLocaBalancing["candyPond"] = "candyPond";
    IdLocaBalancing["candySilo"] = "candySilo";
    IdLocaBalancing["candySimpleHouse"] = "candySimpleHouse";
    IdLocaBalancing["cargoShip"] = "cargoShip";
    IdLocaBalancing["cargoShipCoins"] = "cargoShipCoins";
    IdLocaBalancing["cargoShip_title"] = "cargoShip_title";
    IdLocaBalancing["category_candyProducts"] = "category_candyProducts";
    IdLocaBalancing["category_cargoShipShop"] = "category_cargoShipShop";
    IdLocaBalancing["category_deco"] = "category_deco";
    IdLocaBalancing["category_dogTreats"] = "category_dogTreats";
    IdLocaBalancing["category_dollarPackages"] = "category_dollarPackages";
    IdLocaBalancing["category_effectItems"] = "category_effectItems";
    IdLocaBalancing["category_farmSupplies"] = "category_farmSupplies";
    IdLocaBalancing["category_fishing"] = "category_fishing";
    IdLocaBalancing["category_islandProducts"] = "category_islandProducts";
    IdLocaBalancing["category_loyaltyShop"] = "category_loyaltyShop";
    IdLocaBalancing["category_materials"] = "category_materials";
    IdLocaBalancing["category_nordlandProducts"] = "category_nordlandProducts";
    IdLocaBalancing["category_products"] = "category_products";
    IdLocaBalancing["category_products2"] = "category_products2";
    IdLocaBalancing["category_specialBuildings"] = "category_specialBuildings";
    IdLocaBalancing["category_specialDecorations"] = "category_specialDecorations";
    IdLocaBalancing["category_storage"] = "category_storage";
    IdLocaBalancing["category_tournamentShop"] = "category_tournamentShop";
    IdLocaBalancing["ceremonialTiki"] = "ceremonialTiki";
    IdLocaBalancing["cherries"] = "cherries";
    IdLocaBalancing["cherryBlossoms"] = "cherryBlossoms";
    IdLocaBalancing["cherryOrchard"] = "cherryOrchard";
    IdLocaBalancing["chickenBush"] = "chickenBush";
    IdLocaBalancing["chickenCoop"] = "chickenCoop";
    IdLocaBalancing["chickenCup"] = "chickenCup";
    IdLocaBalancing["chickenFeed15Haste"] = "chickenFeed15Haste";
    IdLocaBalancing["chickenFeed25Haste"] = "chickenFeed25Haste";
    IdLocaBalancing["chickenFeed2Gain"] = "chickenFeed2Gain";
    IdLocaBalancing["chickenFeed3Gain"] = "chickenFeed3Gain";
    IdLocaBalancing["chickenFeed50Haste"] = "chickenFeed50Haste";
    IdLocaBalancing["chickenFeed5Gain"] = "chickenFeed5Gain";
    IdLocaBalancing["chickenfeed"] = "chickenfeed";
    IdLocaBalancing["chickenfeed_premium"] = "chickenfeed_premium";
    IdLocaBalancing["chickenfeed_seaweed"] = "chickenfeed_seaweed";
    IdLocaBalancing["chickenfeed_super"] = "chickenfeed_super";
    IdLocaBalancing["childOfTheWaves"] = "childOfTheWaves";
    IdLocaBalancing["chocolateBunny"] = "chocolateBunny";
    IdLocaBalancing["choosingEffectItem"] = "choosingEffectItem";
    IdLocaBalancing["christmasTree2019"] = "christmasTree2019";
    IdLocaBalancing["citrusFruits"] = "citrusFruits";
    IdLocaBalancing["citrusOil"] = "citrusOil";
    IdLocaBalancing["classicCarousel"] = "classicCarousel";
    IdLocaBalancing["clothesline"] = "clothesline";
    IdLocaBalancing["cocoa"] = "cocoa";
    IdLocaBalancing["cocoaPowder"] = "cocoaPowder";
    IdLocaBalancing["coconutOrchard"] = "coconutOrchard";
    IdLocaBalancing["coconuts"] = "coconuts";
    IdLocaBalancing["collectingEvent_main_title"] = "collectingEvent_main_title";
    IdLocaBalancing["collectingLeague"] = "collectingLeague";
    IdLocaBalancing["comfyHammock"] = "comfyHammock";
    IdLocaBalancing["commonBait"] = "commonBait";
    IdLocaBalancing["commonFillet"] = "commonFillet";
    IdLocaBalancing["composter"] = "composter";
    IdLocaBalancing["conches"] = "conches";
    IdLocaBalancing["confectionary"] = "confectionary";
    IdLocaBalancing["contracts_category1"] = "contracts_category1";
    IdLocaBalancing["contracts_category2"] = "contracts_category2";
    IdLocaBalancing["coopChat_category"] = "coopChat_category";
    IdLocaBalancing["coopFunds"] = "coopFunds";
    IdLocaBalancing["coopHelp_category"] = "coopHelp_category";
    IdLocaBalancing["coopLeague"] = "coopLeague";
    IdLocaBalancing["coopLeagueReward_goldPackage_title"] = "coopLeagueReward_goldPackage_title";
    IdLocaBalancing["coopProjects_projects"] = "coopProjects_projects";
    IdLocaBalancing["cooperative"] = "cooperative";
    IdLocaBalancing["corn"] = "corn";
    IdLocaBalancing["corn15Haste"] = "corn15Haste";
    IdLocaBalancing["corn25Haste"] = "corn25Haste";
    IdLocaBalancing["corn3Gain"] = "corn3Gain";
    IdLocaBalancing["corn4Gain"] = "corn4Gain";
    IdLocaBalancing["corn50Haste"] = "corn50Haste";
    IdLocaBalancing["corn8Gain"] = "corn8Gain";
    IdLocaBalancing["cottonCandyGrapes"] = "cottonCandyGrapes";
    IdLocaBalancing["cottonCandyMachine"] = "cottonCandyMachine";
    IdLocaBalancing["cowBarn"] = "cowBarn";
    IdLocaBalancing["cowCup"] = "cowCup";
    IdLocaBalancing["cowFeed15Haste"] = "cowFeed15Haste";
    IdLocaBalancing["cowFeed25Haste"] = "cowFeed25Haste";
    IdLocaBalancing["cowFeed2Gain"] = "cowFeed2Gain";
    IdLocaBalancing["cowFeed3Gain"] = "cowFeed3Gain";
    IdLocaBalancing["cowFeed50Haste"] = "cowFeed50Haste";
    IdLocaBalancing["cowFeed5Gain"] = "cowFeed5Gain";
    IdLocaBalancing["cowfeed"] = "cowfeed";
    IdLocaBalancing["cowfeed_premium"] = "cowfeed_premium";
    IdLocaBalancing["cowfeed_seaweed"] = "cowfeed_seaweed";
    IdLocaBalancing["cowfeed_super"] = "cowfeed_super";
    IdLocaBalancing["cozyTeaGarden"] = "cozyTeaGarden";
    IdLocaBalancing["crater"] = "crater";
    IdLocaBalancing["criolloCacao"] = "criolloCacao";
    IdLocaBalancing["criolloCacaoOrchard"] = "criolloCacaoOrchard";
    IdLocaBalancing["cropCircles"] = "cropCircles";
    IdLocaBalancing["cultStone"] = "cultStone";
    IdLocaBalancing["daisies"] = "daisies";
    IdLocaBalancing["dandelion"] = "dandelion";
    IdLocaBalancing["dandelion10Gain"] = "dandelion10Gain";
    IdLocaBalancing["dandelion15Haste"] = "dandelion15Haste";
    IdLocaBalancing["dandelion16Gain"] = "dandelion16Gain";
    IdLocaBalancing["dandelion25Haste"] = "dandelion25Haste";
    IdLocaBalancing["dandelion32Gain"] = "dandelion32Gain";
    IdLocaBalancing["dandelion50Haste"] = "dandelion50Haste";
    IdLocaBalancing["deadTree"] = "deadTree";
    IdLocaBalancing["decoCoupons"] = "decoCoupons";
    IdLocaBalancing["dogTreat"] = "dogTreat";
    IdLocaBalancing["dogTreat_premium"] = "dogTreat_premium";
    IdLocaBalancing["dollars"] = "dollars";
    IdLocaBalancing["donkeyStable"] = "donkeyStable";
    IdLocaBalancing["donkeyfeed"] = "donkeyfeed";
    IdLocaBalancing["donkeyfeed_premium"] = "donkeyfeed_premium";
    IdLocaBalancing["donkeyfeed_seaweed"] = "donkeyfeed_seaweed";
    IdLocaBalancing["donkeyfeed_super"] = "donkeyfeed_super";
    IdLocaBalancing["donkeys"] = "donkeys";
    IdLocaBalancing["dragonDance1"] = "dragonDance1";
    IdLocaBalancing["dragonDance2"] = "dragonDance2";
    IdLocaBalancing["dragonDance3"] = "dragonDance3";
    IdLocaBalancing["dragonDance4"] = "dragonDance4";
    IdLocaBalancing["dragonDance5"] = "dragonDance5";
    IdLocaBalancing["dragonDance6"] = "dragonDance6";
    IdLocaBalancing["driedFruits"] = "driedFruits";
    IdLocaBalancing["duckCoop"] = "duckCoop";
    IdLocaBalancing["duckFeathers"] = "duckFeathers";
    IdLocaBalancing["duckFeathers15Haste"] = "duckFeathers15Haste";
    IdLocaBalancing["duckFeathers25Haste"] = "duckFeathers25Haste";
    IdLocaBalancing["duckFeathers27Gain"] = "duckFeathers27Gain";
    IdLocaBalancing["duckFeathers45Gain"] = "duckFeathers45Gain";
    IdLocaBalancing["duckFeathers50Haste"] = "duckFeathers50Haste";
    IdLocaBalancing["duckFeathers90Gain"] = "duckFeathers90Gain";
    IdLocaBalancing["duckFeed15Haste"] = "duckFeed15Haste";
    IdLocaBalancing["duckFeed25Haste"] = "duckFeed25Haste";
    IdLocaBalancing["duckFeed2Gain"] = "duckFeed2Gain";
    IdLocaBalancing["duckFeed3Gain"] = "duckFeed3Gain";
    IdLocaBalancing["duckFeed50Haste"] = "duckFeed50Haste";
    IdLocaBalancing["duckFeed5Gain"] = "duckFeed5Gain";
    IdLocaBalancing["duckPond"] = "duckPond";
    IdLocaBalancing["duckfeed"] = "duckfeed";
    IdLocaBalancing["duckfeed_premium"] = "duckfeed_premium";
    IdLocaBalancing["duckfeed_seaweed"] = "duckfeed_seaweed";
    IdLocaBalancing["duckfeed_super"] = "duckfeed_super";
    IdLocaBalancing["dung"] = "dung";
    IdLocaBalancing["easterBunnies"] = "easterBunnies";
    IdLocaBalancing["easterBunnyInc"] = "easterBunnyInc";
    IdLocaBalancing["easterBunnysHome"] = "easterBunnysHome";
    IdLocaBalancing["easterEgg"] = "easterEgg";
    IdLocaBalancing["easterEggs"] = "easterEggs";
    IdLocaBalancing["easterRibbon"] = "easterRibbon";
    IdLocaBalancing["easterbaskets"] = "easterbaskets";
    IdLocaBalancing["easterfeed"] = "easterfeed";
    IdLocaBalancing["editCoop_category"] = "editCoop_category";
    IdLocaBalancing["eggs"] = "eggs";
    IdLocaBalancing["eggs11Gain"] = "eggs11Gain";
    IdLocaBalancing["eggs15Haste"] = "eggs15Haste";
    IdLocaBalancing["eggs25Haste"] = "eggs25Haste";
    IdLocaBalancing["eggs3Gain"] = "eggs3Gain";
    IdLocaBalancing["eggs50Haste"] = "eggs50Haste";
    IdLocaBalancing["eggs5Gain"] = "eggs5Gain";
    IdLocaBalancing["elvesTable"] = "elvesTable";
    IdLocaBalancing["enchantedTree"] = "enchantedTree";
    IdLocaBalancing["enchantingFairytaleTower"] = "enchantingFairytaleTower";
    IdLocaBalancing["epicFillet"] = "epicFillet";
    IdLocaBalancing["evidencePhotos"] = "evidencePhotos";
    IdLocaBalancing["externalBarn"] = "externalBarn";
    IdLocaBalancing["extravagantElderBush"] = "extravagantElderBush";
    IdLocaBalancing["fancyHouse"] = "fancyHouse";
    IdLocaBalancing["farmFlash"] = "farmFlash";
    IdLocaBalancing["farmHouse"] = "farmHouse";
    IdLocaBalancing["farmName_candy"] = "farmName_candy";
    IdLocaBalancing["farmName_island"] = "farmName_island";
    IdLocaBalancing["farmName_main"] = "farmName_main";
    IdLocaBalancing["farmName_nordland"] = "farmName_nordland";
    IdLocaBalancing["fertileAcre"] = "fertileAcre";
    IdLocaBalancing["fertileAlmondOrchard"] = "fertileAlmondOrchard";
    IdLocaBalancing["fertileAppleOrchard"] = "fertileAppleOrchard";
    IdLocaBalancing["fertileCherryOrchard"] = "fertileCherryOrchard";
    IdLocaBalancing["fertilePeachOrchard"] = "fertilePeachOrchard";
    IdLocaBalancing["fertilizer"] = "fertilizer";
    IdLocaBalancing["fertilizer15Haste"] = "fertilizer15Haste";
    IdLocaBalancing["fertilizer25Haste"] = "fertilizer25Haste";
    IdLocaBalancing["fertilizer2Gain"] = "fertilizer2Gain";
    IdLocaBalancing["fertilizer3Gain"] = "fertilizer3Gain";
    IdLocaBalancing["fertilizer50Haste"] = "fertilizer50Haste";
    IdLocaBalancing["fertilizer5Gain"] = "fertilizer5Gain";
    IdLocaBalancing["fertilizer_premium"] = "fertilizer_premium";
    IdLocaBalancing["fertilizer_seaweed"] = "fertilizer_seaweed";
    IdLocaBalancing["fertilizer_super"] = "fertilizer_super";
    IdLocaBalancing["fireflies"] = "fireflies";
    IdLocaBalancing["firewood"] = "firewood";
    IdLocaBalancing["fishBurger"] = "fishBurger";
    IdLocaBalancing["fishFingers"] = "fishFingers";
    IdLocaBalancing["fishKebab"] = "fishKebab";
    IdLocaBalancing["fishRecipes_title"] = "fishRecipes_title";
    IdLocaBalancing["fishSalad"] = "fishSalad";
    IdLocaBalancing["fishStew"] = "fishStew";
    IdLocaBalancing["fishTacos"] = "fishTacos";
    IdLocaBalancing["fishTins"] = "fishTins";
    IdLocaBalancing["fishingPier"] = "fishingPier";
    IdLocaBalancing["flax"] = "flax";
    IdLocaBalancing["flowerBlossoms"] = "flowerBlossoms";
    IdLocaBalancing["flowerHoney"] = "flowerHoney";
    IdLocaBalancing["flowerNectar"] = "flowerNectar";
    IdLocaBalancing["flowerbed"] = "flowerbed";
    IdLocaBalancing["foliage"] = "foliage";
    IdLocaBalancing["foodTruck"] = "foodTruck";
    IdLocaBalancing["footballoons"] = "footballoons";
    IdLocaBalancing["footballs"] = "footballs";
    IdLocaBalancing["foundCoop_category"] = "foundCoop_category";
    IdLocaBalancing["freeRangeAlmondOrchard"] = "freeRangeAlmondOrchard";
    IdLocaBalancing["freeRangeAppleOrchard"] = "freeRangeAppleOrchard";
    IdLocaBalancing["freeRangeCherryOrchard"] = "freeRangeCherryOrchard";
    IdLocaBalancing["freeRangeChickenCoop"] = "freeRangeChickenCoop";
    IdLocaBalancing["freeRangeCowBarn"] = "freeRangeCowBarn";
    IdLocaBalancing["freeRangeDuckCoop"] = "freeRangeDuckCoop";
    IdLocaBalancing["freeRangeGoatStable"] = "freeRangeGoatStable";
    IdLocaBalancing["freeRangePigPen"] = "freeRangePigPen";
    IdLocaBalancing["fries"] = "fries";
    IdLocaBalancing["frogPrinceWell"] = "frogPrinceWell";
    IdLocaBalancing["fruityFlip"] = "fruityFlip";
    IdLocaBalancing["fuel1Day"] = "fuel1Day";
    IdLocaBalancing["fuel3Day"] = "fuel3Day";
    IdLocaBalancing["fuel7Day"] = "fuel7Day";
    IdLocaBalancing["funnyFlyer"] = "funnyFlyer";
    IdLocaBalancing["galacticGarden"] = "galacticGarden";
    IdLocaBalancing["gifts"] = "gifts";
    IdLocaBalancing["ginger"] = "ginger";
    IdLocaBalancing["gingerbreadHouse"] = "gingerbreadHouse";
    IdLocaBalancing["gingerbreadTrees"] = "gingerbreadTrees";
    IdLocaBalancing["glass"] = "glass";
    IdLocaBalancing["glue"] = "glue";
    IdLocaBalancing["gnomeBath"] = "gnomeBath";
    IdLocaBalancing["gnomeDate"] = "gnomeDate";
    IdLocaBalancing["gnomeFishing"] = "gnomeFishing";
    IdLocaBalancing["gnomeFlowers"] = "gnomeFlowers";
    IdLocaBalancing["gnomeHome"] = "gnomeHome";
    IdLocaBalancing["gnomeHouse"] = "gnomeHouse";
    IdLocaBalancing["gnomePinwheels"] = "gnomePinwheels";
    IdLocaBalancing["goals"] = "goals";
    IdLocaBalancing["goatCheese"] = "goatCheese";
    IdLocaBalancing["goatCheese15Haste"] = "goatCheese15Haste";
    IdLocaBalancing["goatCheese24Gain"] = "goatCheese24Gain";
    IdLocaBalancing["goatCheese25Haste"] = "goatCheese25Haste";
    IdLocaBalancing["goatCheese40Gain"] = "goatCheese40Gain";
    IdLocaBalancing["goatCheese50Haste"] = "goatCheese50Haste";
    IdLocaBalancing["goatCheese80Gain"] = "goatCheese80Gain";
    IdLocaBalancing["goatFeed15Haste"] = "goatFeed15Haste";
    IdLocaBalancing["goatFeed25Haste"] = "goatFeed25Haste";
    IdLocaBalancing["goatFeed2Gain"] = "goatFeed2Gain";
    IdLocaBalancing["goatFeed3Gain"] = "goatFeed3Gain";
    IdLocaBalancing["goatFeed50Haste"] = "goatFeed50Haste";
    IdLocaBalancing["goatFeed5Gain"] = "goatFeed5Gain";
    IdLocaBalancing["goatStable"] = "goatStable";
    IdLocaBalancing["goatfeed"] = "goatfeed";
    IdLocaBalancing["goatfeed_premium"] = "goatfeed_premium";
    IdLocaBalancing["goatfeed_seaweed"] = "goatfeed_seaweed";
    IdLocaBalancing["goatfeed_super"] = "goatfeed_super";
    IdLocaBalancing["gold"] = "gold";
    IdLocaBalancing["goldenAppleOrchard"] = "goldenAppleOrchard";
    IdLocaBalancing["goldenApples"] = "goldenApples";
    IdLocaBalancing["goldenSoccerBall"] = "goldenSoccerBall";
    IdLocaBalancing["goldflowers"] = "goldflowers";
    IdLocaBalancing["grapes"] = "grapes";
    IdLocaBalancing["greenPigment"] = "greenPigment";
    IdLocaBalancing["grilledFish"] = "grilledFish";
    IdLocaBalancing["gumballMachine"] = "gumballMachine";
    IdLocaBalancing["halloweenCandy"] = "halloweenCandy";
    IdLocaBalancing["halloweenfeed"] = "halloweenfeed";
    IdLocaBalancing["hauntedCastle"] = "hauntedCastle";
    IdLocaBalancing["hauntedHouse"] = "hauntedHouse";
    IdLocaBalancing["hawaiianBeach"] = "hawaiianBeach";
    IdLocaBalancing["hawaiianFountain"] = "hawaiianFountain";
    IdLocaBalancing["hayBale"] = "hayBale";
    IdLocaBalancing["heartTrees"] = "heartTrees";
    IdLocaBalancing["herrings"] = "herrings";
    IdLocaBalancing["honey"] = "honey";
    IdLocaBalancing["honeyGlazedFish"] = "honeyGlazedFish";
    IdLocaBalancing["hotDogs"] = "hotDogs";
    IdLocaBalancing["hotSprings"] = "hotSprings";
    IdLocaBalancing["humus"] = "humus";
    IdLocaBalancing["humus15Haste"] = "humus15Haste";
    IdLocaBalancing["humus25Haste"] = "humus25Haste";
    IdLocaBalancing["humus50Haste"] = "humus50Haste";
    IdLocaBalancing["humus_premium"] = "humus_premium";
    IdLocaBalancing["humus_seaweed"] = "humus_seaweed";
    IdLocaBalancing["icicles"] = "icicles";
    IdLocaBalancing["inkPaintings"] = "inkPaintings";
    IdLocaBalancing["inkSets"] = "inkSets";
    IdLocaBalancing["invitations"] = "invitations";
    IdLocaBalancing["islandDung"] = "islandDung";
    IdLocaBalancing["islandFertilizer"] = "islandFertilizer";
    IdLocaBalancing["islandFertilizer_premium"] = "islandFertilizer_premium";
    IdLocaBalancing["islandFertilizer_seaweed"] = "islandFertilizer_seaweed";
    IdLocaBalancing["islandFertilizer_super"] = "islandFertilizer_super";
    IdLocaBalancing["islandFoliage"] = "islandFoliage";
    IdLocaBalancing["islandHumus"] = "islandHumus";
    IdLocaBalancing["islandHumus_premium"] = "islandHumus_premium";
    IdLocaBalancing["islandHumus_seaweed"] = "islandHumus_seaweed";
    IdLocaBalancing["jackOLantern"] = "jackOLantern";
    IdLocaBalancing["jasmine"] = "jasmine";
    IdLocaBalancing["jasmineEssence"] = "jasmineEssence";
    IdLocaBalancing["keys"] = "keys";
    IdLocaBalancing["koiPond"] = "koiPond";
    IdLocaBalancing["lambsLettuce"] = "lambsLettuce";
    IdLocaBalancing["lambsLettuce15Gain"] = "lambsLettuce15Gain";
    IdLocaBalancing["lambsLettuce15Haste"] = "lambsLettuce15Haste";
    IdLocaBalancing["lambsLettuce21Gain"] = "lambsLettuce21Gain";
    IdLocaBalancing["lambsLettuce25Haste"] = "lambsLettuce25Haste";
    IdLocaBalancing["lambsLettuce42Gain"] = "lambsLettuce42Gain";
    IdLocaBalancing["lambsLettuce50Haste"] = "lambsLettuce50Haste";
    IdLocaBalancing["lavaSpring"] = "lavaSpring";
    IdLocaBalancing["lavender"] = "lavender";
    IdLocaBalancing["lavenderEssence"] = "lavenderEssence";
    IdLocaBalancing["leagueMenu_categoryRewards"] = "leagueMenu_categoryRewards";
    IdLocaBalancing["leagueReward_gift_title"] = "leagueReward_gift_title";
    IdLocaBalancing["leagueReward_goldPackage_title"] = "leagueReward_goldPackage_title";
    IdLocaBalancing["legendaryFillet"] = "legendaryFillet";
    IdLocaBalancing["lemurPen"] = "lemurPen";
    IdLocaBalancing["lemurfeed"] = "lemurfeed";
    IdLocaBalancing["lemurfeed_premium"] = "lemurfeed_premium";
    IdLocaBalancing["lemurfeed_seaweed"] = "lemurfeed_seaweed";
    IdLocaBalancing["lemurfeed_super"] = "lemurfeed_super";
    IdLocaBalancing["lemurs"] = "lemurs";
    IdLocaBalancing["logBridge"] = "logBridge";
    IdLocaBalancing["loyaltyPoints"] = "loyaltyPoints";
    IdLocaBalancing["ltpEvent_title"] = "ltpEvent_title";
    IdLocaBalancing["machineParts"] = "machineParts";
    IdLocaBalancing["magicalFairytaleTower"] = "magicalFairytaleTower";
    IdLocaBalancing["magicalWinterTree"] = "magicalWinterTree";
    IdLocaBalancing["magnificentFairytaleTower"] = "magnificentFairytaleTower";
    IdLocaBalancing["magnificentTiki"] = "magnificentTiki";
    IdLocaBalancing["mainFarmFence"] = "mainFarmFence";
    IdLocaBalancing["majesticFairytaleTower"] = "majesticFairytaleTower";
    IdLocaBalancing["mallets"] = "mallets";
    IdLocaBalancing["mangoOrchard"] = "mangoOrchard";
    IdLocaBalancing["mangos"] = "mangos";
    IdLocaBalancing["manufactory"] = "manufactory";
    IdLocaBalancing["mapPieces"] = "mapPieces";
    IdLocaBalancing["marketCertificates"] = "marketCertificates";
    IdLocaBalancing["market_category2"] = "market_category2";
    IdLocaBalancing["marzipan"] = "marzipan";
    IdLocaBalancing["meadow"] = "meadow";
    IdLocaBalancing["milk"] = "milk";
    IdLocaBalancing["milk115Gain"] = "milk115Gain";
    IdLocaBalancing["milk15Haste"] = "milk15Haste";
    IdLocaBalancing["milk25Haste"] = "milk25Haste";
    IdLocaBalancing["milk35Gain"] = "milk35Gain";
    IdLocaBalancing["milk50Haste"] = "milk50Haste";
    IdLocaBalancing["milk58Gain"] = "milk58Gain";
    IdLocaBalancing["multiFarmer"] = "multiFarmer";
    IdLocaBalancing["mysteriousTiki"] = "mysteriousTiki";
    IdLocaBalancing["mysteryChest_adventureMaterials"] = "mysteryChest_adventureMaterials";
    IdLocaBalancing["mysteryChest_commonMaterials"] = "mysteryChest_commonMaterials";
    IdLocaBalancing["mysteryChest_picture1"] = "mysteryChest_picture1";
    IdLocaBalancing["mysteryChest_picture2"] = "mysteryChest_picture2";
    IdLocaBalancing["mysteryChest_picture3"] = "mysteryChest_picture3";
    IdLocaBalancing["mysteryChest_rareMaterials"] = "mysteryChest_rareMaterials";
    IdLocaBalancing["mysteryChests"] = "mysteryChests";
    IdLocaBalancing["mysterychest_couponsBig"] = "mysterychest_couponsBig";
    IdLocaBalancing["mysterychest_couponsSmall"] = "mysterychest_couponsSmall";
    IdLocaBalancing["mysticStoneDragon"] = "mysticStoneDragon";
    IdLocaBalancing["mysticalFairytaleTower"] = "mysticalFairytaleTower";
    IdLocaBalancing["mysticalTiki"] = "mysticalTiki";
    IdLocaBalancing["nails"] = "nails";
    IdLocaBalancing["nectar"] = "nectar";
    IdLocaBalancing["nordicHammers"] = "nordicHammers";
    IdLocaBalancing["nordicNecklaces"] = "nordicNecklaces";
    IdLocaBalancing["nordlandAcre"] = "nordlandAcre";
    IdLocaBalancing["nordlandComposter"] = "nordlandComposter";
    IdLocaBalancing["nordlandDuckCoop"] = "nordlandDuckCoop";
    IdLocaBalancing["nordlandFancyHouse"] = "nordlandFancyHouse";
    IdLocaBalancing["nordlandFarmHouse"] = "nordlandFarmHouse";
    IdLocaBalancing["nordlandGoatStable"] = "nordlandGoatStable";
    IdLocaBalancing["nordlandHouse"] = "nordlandHouse";
    IdLocaBalancing["nordlandMill"] = "nordlandMill";
    IdLocaBalancing["nordlandSilo"] = "nordlandSilo";
    IdLocaBalancing["nordlandSimpleHouse"] = "nordlandSimpleHouse";
    IdLocaBalancing["nurseryBlueprints"] = "nurseryBlueprints";
    IdLocaBalancing["nutsAndGrapes"] = "nutsAndGrapes";
    IdLocaBalancing["oasisOfIdleness"] = "oasisOfIdleness";
    IdLocaBalancing["oasisPool"] = "oasisPool";
    IdLocaBalancing["oktoberfestfeed"] = "oktoberfestfeed";
    IdLocaBalancing["oliveOil"] = "oliveOil";
    IdLocaBalancing["olives"] = "olives";
    IdLocaBalancing["orangeFizz"] = "orangeFizz";
    IdLocaBalancing["oranges"] = "oranges";
    IdLocaBalancing["origamiCranes"] = "origamiCranes";
    IdLocaBalancing["ornamentalTree"] = "ornamentalTree";
    IdLocaBalancing["paint"] = "paint";
    IdLocaBalancing["paintingColor"] = "paintingColor";
    IdLocaBalancing["pavilion"] = "pavilion";
    IdLocaBalancing["pawPrints"] = "pawPrints";
    IdLocaBalancing["peachOrchard"] = "peachOrchard";
    IdLocaBalancing["peaches"] = "peaches";
    IdLocaBalancing["peacockCoop"] = "peacockCoop";
    IdLocaBalancing["peacockfeed"] = "peacockfeed";
    IdLocaBalancing["peacockfeed_premium"] = "peacockfeed_premium";
    IdLocaBalancing["peacockfeed_seaweed"] = "peacockfeed_seaweed";
    IdLocaBalancing["peacockfeed_super"] = "peacockfeed_super";
    IdLocaBalancing["peacocks"] = "peacocks";
    IdLocaBalancing["peanutSnack"] = "peanutSnack";
    IdLocaBalancing["peanuts"] = "peanuts";
    IdLocaBalancing["penguinPool"] = "penguinPool";
    IdLocaBalancing["penguinfeed"] = "penguinfeed";
    IdLocaBalancing["penguinfeed_premium"] = "penguinfeed_premium";
    IdLocaBalancing["penguinfeed_seaweed"] = "penguinfeed_seaweed";
    IdLocaBalancing["penguinfeed_super"] = "penguinfeed_super";
    IdLocaBalancing["penguins"] = "penguins";
    IdLocaBalancing["picnicTable"] = "picnicTable";
    IdLocaBalancing["pigCup"] = "pigCup";
    IdLocaBalancing["pigFeed15Haste"] = "pigFeed15Haste";
    IdLocaBalancing["pigFeed25Haste"] = "pigFeed25Haste";
    IdLocaBalancing["pigFeed2Gain"] = "pigFeed2Gain";
    IdLocaBalancing["pigFeed3Gain"] = "pigFeed3Gain";
    IdLocaBalancing["pigFeed50Haste"] = "pigFeed50Haste";
    IdLocaBalancing["pigFeed5Gain"] = "pigFeed5Gain";
    IdLocaBalancing["pigPen"] = "pigPen";
    IdLocaBalancing["pigfeed"] = "pigfeed";
    IdLocaBalancing["pigfeed_premium"] = "pigfeed_premium";
    IdLocaBalancing["pigfeed_seaweed"] = "pigfeed_seaweed";
    IdLocaBalancing["pigfeed_super"] = "pigfeed_super";
    IdLocaBalancing["pigs"] = "pigs";
    IdLocaBalancing["pigs15Haste"] = "pigs15Haste";
    IdLocaBalancing["pigs20Gain"] = "pigs20Gain";
    IdLocaBalancing["pigs25Haste"] = "pigs25Haste";
    IdLocaBalancing["pigs33Gain"] = "pigs33Gain";
    IdLocaBalancing["pigs50Haste"] = "pigs50Haste";
    IdLocaBalancing["pigs65Gain"] = "pigs65Gain";
    IdLocaBalancing["pillowGreen"] = "pillowGreen";
    IdLocaBalancing["pillowPlain"] = "pillowPlain";
    IdLocaBalancing["pillowPurple"] = "pillowPurple";
    IdLocaBalancing["pillowRed"] = "pillowRed";
    IdLocaBalancing["pineForest"] = "pineForest";
    IdLocaBalancing["pizza"] = "pizza";
    IdLocaBalancing["playerLeague"] = "playerLeague";
    IdLocaBalancing["pralines"] = "pralines";
    IdLocaBalancing["premiumBait"] = "premiumBait";
    IdLocaBalancing["pretzels"] = "pretzels";
    IdLocaBalancing["pulloverGreen"] = "pulloverGreen";
    IdLocaBalancing["pulloverPlain"] = "pulloverPlain";
    IdLocaBalancing["pulloverPurple"] = "pulloverPurple";
    IdLocaBalancing["pulloverRed"] = "pulloverRed";
    IdLocaBalancing["pumpkins"] = "pumpkins";
    IdLocaBalancing["pumpkinsCarved"] = "pumpkinsCarved";
    IdLocaBalancing["purplePigment"] = "purplePigment";
    IdLocaBalancing["pvpLeagueEvent"] = "pvpLeagueEvent";
    IdLocaBalancing["questMenu_adventureQuests"] = "questMenu_adventureQuests";
    IdLocaBalancing["questMenu_mainFarmQuests"] = "questMenu_mainFarmQuests";
    IdLocaBalancing["rankingMenu_category1"] = "rankingMenu_category1";
    IdLocaBalancing["rareFillet"] = "rareFillet";
    IdLocaBalancing["reachLevelX"] = "reachLevelX";
    IdLocaBalancing["redPigment"] = "redPigment";
    IdLocaBalancing["retroClassic"] = "retroClassic";
    IdLocaBalancing["romanticTent"] = "romanticTent";
    IdLocaBalancing["roofingShingles"] = "roofingShingles";
    IdLocaBalancing["ropes"] = "ropes";
    IdLocaBalancing["roses"] = "roses";
    IdLocaBalancing["rubberDucks"] = "rubberDucks";
    IdLocaBalancing["runeCircle"] = "runeCircle";
    IdLocaBalancing["rushingWaterfall"] = "rushingWaterfall";
    IdLocaBalancing["rutabaga"] = "rutabaga";
    IdLocaBalancing["santasPostbox"] = "santasPostbox";
    IdLocaBalancing["santasSleigh"] = "santasSleigh";
    IdLocaBalancing["saplings"] = "saplings";
    IdLocaBalancing["sardines"] = "sardines";
    IdLocaBalancing["saws"] = "saws";
    IdLocaBalancing["scrolls"] = "scrolls";
    IdLocaBalancing["sealPond"] = "sealPond";
    IdLocaBalancing["sealfeed"] = "sealfeed";
    IdLocaBalancing["sealfeed_premium"] = "sealfeed_premium";
    IdLocaBalancing["sealfeed_seaweed"] = "sealfeed_seaweed";
    IdLocaBalancing["sealfeed_super"] = "sealfeed_super";
    IdLocaBalancing["seals"] = "seals";
    IdLocaBalancing["searchCoop_category"] = "searchCoop_category";
    IdLocaBalancing["seashells"] = "seashells";
    IdLocaBalancing["seedbag_aloeVera"] = "seedbag_aloeVera";
    IdLocaBalancing["seedbag_aloeVera_premium"] = "seedbag_aloeVera_premium";
    IdLocaBalancing["seedbag_barley"] = "seedbag_barley";
    IdLocaBalancing["seedbag_barley_premium"] = "seedbag_barley_premium";
    IdLocaBalancing["seedbag_cabbage"] = "seedbag_cabbage";
    IdLocaBalancing["seedbag_cabbage_premium"] = "seedbag_cabbage_premium";
    IdLocaBalancing["seedbag_citrusFruits"] = "seedbag_citrusFruits";
    IdLocaBalancing["seedbag_citrusFruits_premium"] = "seedbag_citrusFruits_premium";
    IdLocaBalancing["seedbag_cocoa"] = "seedbag_cocoa";
    IdLocaBalancing["seedbag_cocoa_premium"] = "seedbag_cocoa_premium";
    IdLocaBalancing["seedbag_corn"] = "seedbag_corn";
    IdLocaBalancing["seedbag_corn_premium"] = "seedbag_corn_premium";
    IdLocaBalancing["seedbag_cottonCandyGrapes"] = "seedbag_cottonCandyGrapes";
    IdLocaBalancing["seedbag_cottonCandyGrapes_premium"] = "seedbag_cottonCandyGrapes_premium";
    IdLocaBalancing["seedbag_daisies"] = "seedbag_daisies";
    IdLocaBalancing["seedbag_daisies_premium"] = "seedbag_daisies_premium";
    IdLocaBalancing["seedbag_dandelion"] = "seedbag_dandelion";
    IdLocaBalancing["seedbag_dandelion_premium"] = "seedbag_dandelion_premium";
    IdLocaBalancing["seedbag_flax"] = "seedbag_flax";
    IdLocaBalancing["seedbag_flax_premium"] = "seedbag_flax_premium";
    IdLocaBalancing["seedbag_ginger"] = "seedbag_ginger";
    IdLocaBalancing["seedbag_ginger_premium"] = "seedbag_ginger_premium";
    IdLocaBalancing["seedbag_goldflowers"] = "seedbag_goldflowers";
    IdLocaBalancing["seedbag_grapes"] = "seedbag_grapes";
    IdLocaBalancing["seedbag_grapes_premium"] = "seedbag_grapes_premium";
    IdLocaBalancing["seedbag_herrings"] = "seedbag_herrings";
    IdLocaBalancing["seedbag_herrings_premium"] = "seedbag_herrings_premium";
    IdLocaBalancing["seedbag_jasmine"] = "seedbag_jasmine";
    IdLocaBalancing["seedbag_jasmine_premium"] = "seedbag_jasmine_premium";
    IdLocaBalancing["seedbag_lambsLettuce"] = "seedbag_lambsLettuce";
    IdLocaBalancing["seedbag_lambsLettuce_premium"] = "seedbag_lambsLettuce_premium";
    IdLocaBalancing["seedbag_lavender"] = "seedbag_lavender";
    IdLocaBalancing["seedbag_lavender_premium"] = "seedbag_lavender_premium";
    IdLocaBalancing["seedbag_olives"] = "seedbag_olives";
    IdLocaBalancing["seedbag_olives_premium"] = "seedbag_olives_premium";
    IdLocaBalancing["seedbag_oranges"] = "seedbag_oranges";
    IdLocaBalancing["seedbag_oranges_premium"] = "seedbag_oranges_premium";
    IdLocaBalancing["seedbag_peanuts"] = "seedbag_peanuts";
    IdLocaBalancing["seedbag_peanuts_premium"] = "seedbag_peanuts_premium";
    IdLocaBalancing["seedbag_pumpkins"] = "seedbag_pumpkins";
    IdLocaBalancing["seedbag_pumpkins_premium"] = "seedbag_pumpkins_premium";
    IdLocaBalancing["seedbag_roses"] = "seedbag_roses";
    IdLocaBalancing["seedbag_rutabaga"] = "seedbag_rutabaga";
    IdLocaBalancing["seedbag_rutabaga_premium"] = "seedbag_rutabaga_premium";
    IdLocaBalancing["seedbag_sardines"] = "seedbag_sardines";
    IdLocaBalancing["seedbag_sardines_premium"] = "seedbag_sardines_premium";
    IdLocaBalancing["seedbag_sugarBeets"] = "seedbag_sugarBeets";
    IdLocaBalancing["seedbag_sugarBeets_premium"] = "seedbag_sugarBeets_premium";
    IdLocaBalancing["seedbag_sugarCane"] = "seedbag_sugarCane";
    IdLocaBalancing["seedbag_sugarCane_premium"] = "seedbag_sugarCane_premium";
    IdLocaBalancing["seedbag_vanilla"] = "seedbag_vanilla";
    IdLocaBalancing["seedbag_vanilla_premium"] = "seedbag_vanilla_premium";
    IdLocaBalancing["seedbag_wheat"] = "seedbag_wheat";
    IdLocaBalancing["seedbag_wheat_premium"] = "seedbag_wheat_premium";
    IdLocaBalancing["seedbag_wildflowers"] = "seedbag_wildflowers";
    IdLocaBalancing["seedbag_wildflowers_premium"] = "seedbag_wildflowers_premium";
    IdLocaBalancing["seedbag_xpFlowers"] = "seedbag_xpFlowers";
    IdLocaBalancing["settingsMenu_category1"] = "settingsMenu_category1";
    IdLocaBalancing["settingsMenu_category2"] = "settingsMenu_category2";
    IdLocaBalancing["sheepFeed15Haste"] = "sheepFeed15Haste";
    IdLocaBalancing["sheepFeed25Haste"] = "sheepFeed25Haste";
    IdLocaBalancing["sheepFeed2Gain"] = "sheepFeed2Gain";
    IdLocaBalancing["sheepFeed3Gain"] = "sheepFeed3Gain";
    IdLocaBalancing["sheepFeed50Haste"] = "sheepFeed50Haste";
    IdLocaBalancing["sheepFeed5Gain"] = "sheepFeed5Gain";
    IdLocaBalancing["sheepPen"] = "sheepPen";
    IdLocaBalancing["sheepWool"] = "sheepWool";
    IdLocaBalancing["sheepWool15Haste"] = "sheepWool15Haste";
    IdLocaBalancing["sheepWool25Haste"] = "sheepWool25Haste";
    IdLocaBalancing["sheepWool27Gain"] = "sheepWool27Gain";
    IdLocaBalancing["sheepWool45Gain"] = "sheepWool45Gain";
    IdLocaBalancing["sheepWool50Haste"] = "sheepWool50Haste";
    IdLocaBalancing["sheepWool90Gain"] = "sheepWool90Gain";
    IdLocaBalancing["sheepfeed"] = "sheepfeed";
    IdLocaBalancing["sheepfeed_premium"] = "sheepfeed_premium";
    IdLocaBalancing["sheepfeed_seaweed"] = "sheepfeed_seaweed";
    IdLocaBalancing["sheepfeed_super"] = "sheepfeed_super";
    IdLocaBalancing["silentLamb"] = "silentLamb";
    IdLocaBalancing["silo"] = "silo";
    IdLocaBalancing["simpleHouse"] = "simpleHouse";
    IdLocaBalancing["simpleTiki"] = "simpleTiki";
    IdLocaBalancing["sleighWithGifts"] = "sleighWithGifts";
    IdLocaBalancing["smallChristmasGift"] = "smallChristmasGift";
    IdLocaBalancing["smallPalmTree"] = "smallPalmTree";
    IdLocaBalancing["snakeOil"] = "snakeOil";
    IdLocaBalancing["snippets"] = "snippets";
    IdLocaBalancing["snowflakes"] = "snowflakes";
    IdLocaBalancing["socksGreen"] = "socksGreen";
    IdLocaBalancing["socksPlain"] = "socksPlain";
    IdLocaBalancing["socksPurple"] = "socksPurple";
    IdLocaBalancing["socksRed"] = "socksRed";
    IdLocaBalancing["specialCoupons"] = "specialCoupons";
    IdLocaBalancing["specialPress"] = "specialPress";
    IdLocaBalancing["spookyWell"] = "spookyWell";
    IdLocaBalancing["springFountain"] = "springFountain";
    IdLocaBalancing["stackmaster"] = "stackmaster";
    IdLocaBalancing["starSphere1"] = "starSphere1";
    IdLocaBalancing["starSphere2"] = "starSphere2";
    IdLocaBalancing["starSphere3"] = "starSphere3";
    IdLocaBalancing["starSphere4"] = "starSphere4";
    IdLocaBalancing["starSphere5"] = "starSphere5";
    IdLocaBalancing["starSphere6"] = "starSphere6";
    IdLocaBalancing["statelyFairytaleTower"] = "statelyFairytaleTower";
    IdLocaBalancing["storybookPages"] = "storybookPages";
    IdLocaBalancing["strangeTracks"] = "strangeTracks";
    IdLocaBalancing["sugarBeets"] = "sugarBeets";
    IdLocaBalancing["sugarCane"] = "sugarCane";
    IdLocaBalancing["sugarFigures"] = "sugarFigures";
    IdLocaBalancing["summerBeachCowChilling"] = "summerBeachCowChilling";
    IdLocaBalancing["summerBeachPlayingVolley"] = "summerBeachPlayingVolley";
    IdLocaBalancing["summerSlush"] = "summerSlush";
    IdLocaBalancing["superBait"] = "superBait";
    IdLocaBalancing["sushi"] = "sushi";
    IdLocaBalancing["sweetheartCherries"] = "sweetheartCherries";
    IdLocaBalancing["sweetheartCherryOrchard"] = "sweetheartCherryOrchard";
    IdLocaBalancing["sweets"] = "sweets";
    IdLocaBalancing["syrup"] = "syrup";
    IdLocaBalancing["tacos"] = "tacos";
    IdLocaBalancing["tailorShop"] = "tailorShop";
    IdLocaBalancing["tailorShopProducts"] = "tailorShopProducts";
    IdLocaBalancing["tailorShop_title"] = "tailorShop_title";
    IdLocaBalancing["task_buyGold_title"] = "task_buyGold_title";
    IdLocaBalancing["task_choosePlayerName_title"] = "task_choosePlayerName_title";
    IdLocaBalancing["task_collectResource_title"] = "task_collectResource_title";
    IdLocaBalancing["task_collectSpecialDrop_title"] = "task_collectSpecialDrop_title";
    IdLocaBalancing["task_collectWater_title"] = "task_collectWater_title";
    IdLocaBalancing["task_construct_title"] = "task_construct_title";
    IdLocaBalancing["task_cultivateResource_title"] = "task_cultivateResource_title";
    IdLocaBalancing["task_earnResource_title"] = "task_earnResource_title";
    IdLocaBalancing["task_fillCargoCrate_title"] = "task_fillCargoCrate_title";
    IdLocaBalancing["task_fryingFishRestaurant_title"] = "task_fryingFishRestaurant_title";
    IdLocaBalancing["task_fulfillContracts_title"] = "task_fulfillContracts_title";
    IdLocaBalancing["task_giveDogTreat_title"] = "task_giveDogTreat_title";
    IdLocaBalancing["task_goFishing_title"] = "task_goFishing_title";
    IdLocaBalancing["task_haveBuildingsStage_title"] = "task_haveBuildingsStage_title";
    IdLocaBalancing["task_haveBuildings_title"] = "task_haveBuildings_title";
    IdLocaBalancing["task_haveDecorations_title"] = "task_haveDecorations_title";
    IdLocaBalancing["task_haveExpansion_title"] = "task_haveExpansion_title";
    IdLocaBalancing["task_haveHappiness_title"] = "task_haveHappiness_title";
    IdLocaBalancing["task_improveCargoShip_title"] = "task_improveCargoShip_title";
    IdLocaBalancing["task_improveLibrary_title"] = "task_improveLibrary_title";
    IdLocaBalancing["task_improveMarket_title"] = "task_improveMarket_title";
    IdLocaBalancing["task_inviteFriends_title"] = "task_inviteFriends_title";
    IdLocaBalancing["task_joinCoop_title"] = "task_joinCoop_title";
    IdLocaBalancing["task_prepareDishFishRestaurant_title"] = "task_prepareDishFishRestaurant_title";
    IdLocaBalancing["task_sendCargoShip_title"] = "task_sendCargoShip_title";
    IdLocaBalancing["task_spendResource_title"] = "task_spendResource_title";
    IdLocaBalancing["task_startProduction_title"] = "task_startProduction_title";
    IdLocaBalancing["task_tailoring2_makePlainPillow_title"] = "task_tailoring2_makePlainPillow_title";
    IdLocaBalancing["task_tailoring3_makePlainBeanie_title"] = "task_tailoring3_makePlainBeanie_title";
    IdLocaBalancing["task_tailoring5_makeRedPillow_title"] = "task_tailoring5_makeRedPillow_title";
    IdLocaBalancing["task_upgradeToStage_title"] = "task_upgradeToStage_title";
    IdLocaBalancing["task_useCafe_title"] = "task_useCafe_title";
    IdLocaBalancing["task_useHumus_title"] = "task_useHumus_title";
    IdLocaBalancing["task_useSpecialPress_title"] = "task_useSpecialPress_title";
    IdLocaBalancing["tasks_easterContent_openGiftbox_title"] = "tasks_easterContent_openGiftbox_title";
    IdLocaBalancing["thicket"] = "thicket";
    IdLocaBalancing["tooltip_doghouse_web"] = "tooltip_doghouse_web";
    IdLocaBalancing["tooltip_eventHub_web"] = "tooltip_eventHub_web";
    IdLocaBalancing["tooltip_library_web"] = "tooltip_library_web";
    IdLocaBalancing["tooltip_nursery_web"] = "tooltip_nursery_web";
    IdLocaBalancing["tooltip_tournaments_web"] = "tooltip_tournaments_web";
    IdLocaBalancing["tournament"] = "tournament";
    IdLocaBalancing["tournamentCoins"] = "tournamentCoins";
    IdLocaBalancing["tournamentMenu_leagueRankings"] = "tournamentMenu_leagueRankings";
    IdLocaBalancing["tracks"] = "tracks";
    IdLocaBalancing["tractor"] = "tractor";
    IdLocaBalancing["traditionalTiki"] = "traditionalTiki";
    IdLocaBalancing["treeGrove"] = "treeGrove";
    IdLocaBalancing["treeNursery"] = "treeNursery";
    IdLocaBalancing["treeOfLanterns"] = "treeOfLanterns";
    IdLocaBalancing["treeSaplings"] = "treeSaplings";
    IdLocaBalancing["trophies"] = "trophies";
    IdLocaBalancing["tropicStar"] = "tropicStar";
    IdLocaBalancing["tropicalAcre"] = "tropicalAcre";
    IdLocaBalancing["tropicalChickenCoop"] = "tropicalChickenCoop";
    IdLocaBalancing["tropicalComposter"] = "tropicalComposter";
    IdLocaBalancing["tropicalCowBarn"] = "tropicalCowBarn";
    IdLocaBalancing["tropicalFancyHouse"] = "tropicalFancyHouse";
    IdLocaBalancing["tropicalFarmHouse"] = "tropicalFarmHouse";
    IdLocaBalancing["tropicalHouse"] = "tropicalHouse";
    IdLocaBalancing["tropicalMill"] = "tropicalMill";
    IdLocaBalancing["tropicalPigPen"] = "tropicalPigPen";
    IdLocaBalancing["tropicalSilo"] = "tropicalSilo";
    IdLocaBalancing["tropicalSimpleHouse"] = "tropicalSimpleHouse";
    IdLocaBalancing["twigs"] = "twigs";
    IdLocaBalancing["twinklingSnowman"] = "twinklingSnowman";
    IdLocaBalancing["ufoParts"] = "ufoParts";
    IdLocaBalancing["uncommonBait"] = "uncommonBait";
    IdLocaBalancing["uncommonFillet"] = "uncommonFillet";
    IdLocaBalancing["unicornStatue"] = "unicornStatue";
    IdLocaBalancing["uniqueWindmill"] = "uniqueWindmill";
    IdLocaBalancing["upgradableStarSphere"] = "upgradableStarSphere";
    IdLocaBalancing["upgrade"] = "upgrade";
    IdLocaBalancing["vanilla"] = "vanilla";
    IdLocaBalancing["vanillaExtract"] = "vanillaExtract";
    IdLocaBalancing["vegetablePatch"] = "vegetablePatch";
    IdLocaBalancing["victoryCoins"] = "victoryCoins";
    IdLocaBalancing["vikingCoats"] = "vikingCoats";
    IdLocaBalancing["vikingMeals"] = "vikingMeals";
    IdLocaBalancing["vikingTunics"] = "vikingTunics";
    IdLocaBalancing["vikingWorkshop"] = "vikingWorkshop";
    IdLocaBalancing["water"] = "water";
    IdLocaBalancing["watertower"] = "watertower";
    IdLocaBalancing["watertowerBlueprints"] = "watertowerBlueprints";
    IdLocaBalancing["weddingBouquet"] = "weddingBouquet";
    IdLocaBalancing["weddingCakes"] = "weddingCakes";
    IdLocaBalancing["weddingPavilion"] = "weddingPavilion";
    IdLocaBalancing["weddingPresents"] = "weddingPresents";
    IdLocaBalancing["well"] = "well";
    IdLocaBalancing["wellspringOfCharity"] = "wellspringOfCharity";
    IdLocaBalancing["westernWindmill"] = "westernWindmill";
    IdLocaBalancing["wheat"] = "wheat";
    IdLocaBalancing["wheat15Gain"] = "wheat15Gain";
    IdLocaBalancing["wheat15Haste"] = "wheat15Haste";
    IdLocaBalancing["wheat24Gain"] = "wheat24Gain";
    IdLocaBalancing["wheat25Haste"] = "wheat25Haste";
    IdLocaBalancing["wheat48Gain"] = "wheat48Gain";
    IdLocaBalancing["wheat50Haste"] = "wheat50Haste";
    IdLocaBalancing["wildflowers"] = "wildflowers";
    IdLocaBalancing["wildflowers15Haste"] = "wildflowers15Haste";
    IdLocaBalancing["wildflowers25Haste"] = "wildflowers25Haste";
    IdLocaBalancing["wildflowers2Gain"] = "wildflowers2Gain";
    IdLocaBalancing["wildflowers3Gain"] = "wildflowers3Gain";
    IdLocaBalancing["wildflowers50Haste"] = "wildflowers50Haste";
    IdLocaBalancing["wildflowers6Gain"] = "wildflowers6Gain";
    IdLocaBalancing["windmill"] = "windmill";
    IdLocaBalancing["winterBaubleBlue"] = "winterBaubleBlue";
    IdLocaBalancing["winterBaubleGreen"] = "winterBaubleGreen";
    IdLocaBalancing["winterBaubleRed"] = "winterBaubleRed";
    IdLocaBalancing["winterCommonCoin"] = "winterCommonCoin";
    IdLocaBalancing["winterEpicCoin"] = "winterEpicCoin";
    IdLocaBalancing["winterLights"] = "winterLights";
    IdLocaBalancing["winterStar"] = "winterStar";
    IdLocaBalancing["winterWonder"] = "winterWonder";
    IdLocaBalancing["winterfeed"] = "winterfeed";
    IdLocaBalancing["wood"] = "wood";
    IdLocaBalancing["xDogTreats"] = "xDogTreats";
    IdLocaBalancing["xDogTreatsPremium"] = "xDogTreatsPremium";
    IdLocaBalancing["xDollars"] = "xDollars";
})(IdLocaBalancing || (IdLocaBalancing = {}));
export var ShopCategoryType;
(function (ShopCategoryType) {
    ShopCategoryType["None"] = "none";
    ShopCategoryType["Fence"] = "fence";
    ShopCategoryType["Facilities"] = "facilities";
    ShopCategoryType["ResidentialBuildings"] = "residentialBuildings";
    ShopCategoryType["Decorations"] = "decorations";
    ShopCategoryType["Acres"] = "acres";
    ShopCategoryType["ChickenCoops"] = "chickenCoops";
    ShopCategoryType["PigPens"] = "pigPens";
    ShopCategoryType["CowBarns"] = "cowBarns";
    ShopCategoryType["GoatStables"] = "goatStables";
    ShopCategoryType["DuckCoops"] = "duckCoops";
    ShopCategoryType["SheepPens"] = "sheepPens";
    ShopCategoryType["AppleOrchards"] = "appleOrchards";
    ShopCategoryType["CherryOrchards"] = "cherryOrchards";
    ShopCategoryType["AlmondOrchards"] = "almondOrchards";
    ShopCategoryType["PeachOrchards"] = "peachOrchards";
    ShopCategoryType["Windmills"] = "windmills";
    ShopCategoryType["Silos"] = "silos";
    ShopCategoryType["Composters"] = "composters";
    ShopCategoryType["Meadows"] = "meadows";
    ShopCategoryType["Manufactories"] = "manufactories";
    ShopCategoryType["AdvResidentials"] = "advResidentials";
    ShopCategoryType["AdvAcres"] = "advAcres";
    ShopCategoryType["AdvDecos"] = "advDecos";
})(ShopCategoryType || (ShopCategoryType = {}));
export var CoopPermissionType;
(function (CoopPermissionType) {
    CoopPermissionType["CanEditCoopStats"] = "canEditCoopStats";
    CoopPermissionType["CanPromoteLeader"] = "canPromoteLeader";
    CoopPermissionType["CanPromoteDeputy"] = "canPromoteDeputy";
    CoopPermissionType["CanPromoteMember"] = "canPromoteMember";
    CoopPermissionType["CanKickLeader"] = "canKickLeader";
    CoopPermissionType["CanKickDeputy"] = "canKickDeputy";
    CoopPermissionType["CanKickMember"] = "canKickMember";
    CoopPermissionType["CanKickCandidate"] = "canKickCandidate";
    CoopPermissionType["CanEditProjects"] = "canEditProjects";
    CoopPermissionType["CanInvite"] = "canInvite";
    CoopPermissionType["CanSpendFunds"] = "canSpendFunds";
})(CoopPermissionType || (CoopPermissionType = {}));
export var BuffHierarchyType;
(function (BuffHierarchyType) {
    BuffHierarchyType["ALLIANCE"] = "ALLIANCE";
    BuffHierarchyType["PLAYER"] = "PLAYER";
    BuffHierarchyType["FARM"] = "FARM";
    BuffHierarchyType["BUILDING_CATEGORY"] = "BUILDING_CATEGORY";
    BuffHierarchyType["BUILDING_GROUP"] = "BUILDING_GROUP";
    BuffHierarchyType["BUILDING"] = "BUILDING";
    BuffHierarchyType["FARM_ADVENTURE"] = "FARM_ADVENTURE";
})(BuffHierarchyType || (BuffHierarchyType = {}));
export var BuffContextType;
(function (BuffContextType) {
    BuffContextType["ANY_CONTEXT"] = "ANY_CONTEXT";
    BuffContextType["PRODUCTION"] = "PRODUCTION";
    BuffContextType["CONSTRUCTION"] = "CONSTRUCTION";
    BuffContextType["EXPANSION"] = "EXPANSION";
    BuffContextType["TRADE"] = "TRADE";
    BuffContextType["MISSION"] = "MISSION";
    BuffContextType["EVENT"] = "EVENT";
    BuffContextType["CONTRACT"] = "CONTRACT";
    BuffContextType["CAFE"] = "CAFE";
    BuffContextType["PROJECT"] = "PROJECT";
    BuffContextType["FISH"] = "FISH";
    BuffContextType["OFFER"] = "OFFER";
    BuffContextType["CARGO_CRATE"] = "CARGO_CRATE";
    BuffContextType["CARGO_HOLD"] = "CARGO_HOLD";
})(BuffContextType || (BuffContextType = {}));
export var BuffTargetType;
(function (BuffTargetType) {
    BuffTargetType["ANY_TARGET"] = "ANY_TARGET";
    BuffTargetType["TIME"] = "TIME";
    BuffTargetType["COST"] = "COST";
    BuffTargetType["PRODUCT"] = "PRODUCT";
    BuffTargetType["REVENUE"] = "REVENUE";
    BuffTargetType["XP"] = "XP";
    BuffTargetType["FAME"] = "FAME";
    BuffTargetType["MARKET_XP"] = "MARKET_XP";
    BuffTargetType["ADVENTURER_XP"] = "ADVENTURER_XP";
    BuffTargetType["HAPPINESS"] = "HAPPINESS";
    BuffTargetType["SATISFACTION"] = "SATISFACTION";
    BuffTargetType["POINTS"] = "POINTS";
    BuffTargetType["FISHING_XP"] = "FISHING_XP";
    BuffTargetType["HIT_AREA"] = "HIT_AREA";
    BuffTargetType["CARGO_XP"] = "CARGO_XP";
    BuffTargetType["REVENUE_BOOSTER"] = "REVENUE_BOOSTER";
})(BuffTargetType || (BuffTargetType = {}));
export var UnlockItemRewardEnum;
(function (UnlockItemRewardEnum) {
    UnlockItemRewardEnum["Dummy"] = "dummy";
    UnlockItemRewardEnum["AdditionalBuildQueueSlot_mainFarm"] = "additionalBuildQueueSlot_mainFarm";
    UnlockItemRewardEnum["AdditionalBuildQueueSlot_islandFarm"] = "additionalBuildQueueSlot_islandFarm";
    UnlockItemRewardEnum["AdditionalBuildQueueSlot_nordlandFarm"] = "additionalBuildQueueSlot_nordlandFarm";
    UnlockItemRewardEnum["AdditionalBuildQueueSlot_candyFarm"] = "additionalBuildQueueSlot_candyFarm";
})(UnlockItemRewardEnum || (UnlockItemRewardEnum = {}));
export var OfferCategoryType;
(function (OfferCategoryType) {
    OfferCategoryType["Unknown"] = "Unknown";
    OfferCategoryType["SingleOffer"] = "SingleOffer";
    OfferCategoryType["BundledOffer"] = "BundledOffer";
    OfferCategoryType["GrowthBasedOffer"] = "GrowthBasedOffer";
    OfferCategoryType["SubscriptionBigFarmClub"] = "SubscriptionBigFarmClub";
    OfferCategoryType["SubscriptionGoldOffers"] = "SubscriptionGoldOffers";
    OfferCategoryType["SeasonPassOffer"] = "SeasonPassOffer";
    OfferCategoryType["SmsPackage"] = "SmsPackage";
    OfferCategoryType["PiggyBankOffer"] = "PiggyBankOffer";
    OfferCategoryType["PromoOffer"] = "PromoOffer";
})(OfferCategoryType || (OfferCategoryType = {}));
export var SeasonPassCategoryType;
(function (SeasonPassCategoryType) {
    SeasonPassCategoryType["NORMAL"] = "NORMAL";
    SeasonPassCategoryType["SEASON_PASS_1"] = "SEASON_PASS_1";
    SeasonPassCategoryType["SEASON_PASS_2"] = "SEASON_PASS_2";
})(SeasonPassCategoryType || (SeasonPassCategoryType = {}));
export var AvailableToPlatformsType;
(function (AvailableToPlatformsType) {
    AvailableToPlatformsType["All"] = "All";
    AvailableToPlatformsType["None"] = "None";
    AvailableToPlatformsType["GooglePlay"] = "GooglePlay";
    AvailableToPlatformsType["ITunes"] = "iTunes";
    AvailableToPlatformsType["Amazon"] = "Amazon";
    AvailableToPlatformsType["MobileAndTablet"] = "MobileAndTablet";
    AvailableToPlatformsType["WebBrowser"] = "WebBrowser";
    AvailableToPlatformsType["Android"] = "Android";
})(AvailableToPlatformsType || (AvailableToPlatformsType = {}));
export var EventType;
(function (EventType) {
    EventType["PlayerThemed"] = "playerThemed";
    EventType["PlayerPoints"] = "playerPoints";
    EventType["CoopPoints"] = "coopPoints";
    EventType["PlayerLeague"] = "playerLeague";
    EventType["CoopLeague"] = "coopLeague";
    EventType["TemporaryFarm"] = "temporaryFarm";
    EventType["DailyCustomer"] = "dailyCustomer";
    EventType["CollectLeague"] = "collectLeague";
    EventType["ExpansionDiscount"] = "expansionDiscount";
    EventType["PurchasePoints"] = "purchasePoints";
    EventType["Trader"] = "trader";
    EventType["CoopProjectsBonus"] = "coopProjectsBonus";
    EventType["OutskirtDiscount"] = "outskirtDiscount";
    EventType["QuestTree"] = "questTree";
    EventType["FertileAcreDiscount"] = "fertileAcreDiscount";
    EventType["FancyHouseDiscount"] = "fancyHouseDiscount";
    EventType["FertileOrchardsDiscount"] = "fertileOrchardsDiscount";
    EventType["FortuneTeller"] = "fortuneTeller";
    EventType["DailyLogin"] = "dailyLogin";
    EventType["LongTermPlayerEvent"] = "longTermPlayerEvent";
    EventType["PrimeTime"] = "primeTime";
    EventType["PrimeSale"] = "primeSale";
    EventType["PvpMapLeague"] = "pvpMapLeague";
    EventType["ImprovementDiscount"] = "improvementDiscount";
    EventType["SlotMachine"] = "slotMachine";
})(EventType || (EventType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/balancing/types/BalancingCore.ts
// module id = 26
// module chunks = 3